import { defineStore } from "pinia";
import { manageApiCall } from "@movinglayers/api";
import { computed, ref } from "vue";
import { useAppLifecycleStore } from "./app-lifecycle.ts";
import { useFenceStore } from "./fence.ts";
import { Monitoring } from "@movinglayers/monitoring/frontend";

const interval = 10 * 60 * 1000; // 10 minutes

export const useSyncStore = defineStore("sync", () => {

    const lifecyleStore = useAppLifecycleStore();
    const fenceStore = useFenceStore();

    const timerId = ref<ReturnType<typeof setInterval> | null>(null);
    const isSyncing = computed(() => timerId.value !== null);

    const resetTimerId = () => {
        if (timerId.value) {
            clearInterval(timerId.value);
            timerId.value = null;
        }
    }

    const sync = () => {
        manageApiCall(fenceStore.retrieveAndStoreFences, { 
            preRequestCheck: {
                check: () => lifecyleStore.canDoServerRequests, // TODO: check if sync should happen when app in background
                fallbackValue: null,
                onAbort: () => resetTimerId()
            },
            failHandlers: {
                onFail: (error: any) => Monitoring.chainError("Failed to sync fences", error)
            }
         })
         .makeRequest()
    }

    const startSyncInterval = () => {
        resetTimerId();
        sync();
        timerId.value = setInterval(sync, interval);
    };

    const stopSyncInterval = () => {
        resetTimerId();
    }

    return { startSyncInterval, isSyncing, stopSyncInterval };
});